import { useState } from "react";
import { Formik, Form } from "formik";
import * as yup from "yup";

import { IAuthLoginDTO } from "../../../modules/user/models/IAuthService";
import { BrandedSplitLayout } from "../../../branding/components/BrandedSplitLayout";
import { BrandedFormHeader } from "../../../branding/components/BrandedFormHeader";
import { BrandedSecondaryAction } from "../../../branding/components/BrandedSecondaryAction";
import { BrandedTextField } from "../../../branding/components/BrandedTextField";
import { BrandedButton } from "../../../branding/components/BrandedButton";
import { routesConfig } from "../../../config/routes";
import { useSecurityAuth } from "../SecurityAuthDefault/hook/useSecurityAuth";

const onlyDigits = (v: string) => v.replace(/\D/g, "").slice(0, 6);

const validationSchema = yup.object().shape({
  // mfaToken flui como string (filtro de dígitos + maxLength=6); validar como string preserva
  // zero à esquerda e não esbarra na precisão de Number.
  mfaToken: yup
    .string()
    .required("Este campo é obrigatório")
    .matches(/^\d{6}$/, "O código deve ter 6 dígitos"),
});

// SecurityAuth Branded: layout split + UM TextField MUI para o código de 6 dígitos (sem o
// style.css global). Reusa useSecurityAuth — nenhuma lógica de MFA duplicada. Cores/typografia
// do tema.
const SecurityAuthBranded = (): JSX.Element => {
  const { handleSubmit, handleResendCode, email, password } = useSecurityAuth();
  const [resending, setResending] = useState(false);

  const onResend = async () => {
    setResending(true);
    await handleResendCode();
    setResending(false);
  };

  return (
    <Formik
      initialValues={{ email, password, mfaToken: "" } as IAuthLoginDTO}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue, isSubmitting }) => (
        <Form>
          <BrandedSplitLayout>
            <BrandedFormHeader
              title="Verificação em dois fatores"
              subtitle={`Enviamos o código de verificação para ${email}.`}
            />

            <BrandedTextField
              name="mfaToken"
              label="Código de verificação"
              value={values.mfaToken}
              onChange={(e) => setFieldValue("mfaToken", onlyDigits(e.target.value))}
              placeholder="000000"
              inputProps={{
                inputMode: "numeric",
                autoComplete: "one-time-code",
                maxLength: 6,
                style: {
                  textAlign: "center",
                  letterSpacing: "0.4em",
                  fontFamily: "monospace",
                  fontSize: "2.4rem",
                },
              }}
            />

            <BrandedButton type="submit" loading={isSubmitting}>
              Verificar e entrar
            </BrandedButton>

            <BrandedSecondaryAction
              actions={[
                { label: "Voltar", to: routesConfig.LOGIN },
                { label: "Reenviar código", onClick: onResend, loading: resending },
              ]}
            />
          </BrandedSplitLayout>
        </Form>
      )}
    </Formik>
  );
};

export default SecurityAuthBranded;
